import { render, staticRenderFns } from "./add-field.vue?vue&type=template&id=f5bc72c0"
import script from "./add-field.vue?vue&type=script&lang=js"
export * from "./add-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports